<script setup lang="ts">
import type { Props } from './types';

defineProps<Props>();
</script>

<template>
	<div
		:class="{
			['top-preloader-' + type]:true,
		}"
	>
		<template v-if="type === 'circles'">
			<i v-for="_n in [1,2,3]"></i>
		</template>
	</div>
</template>

<style>
:root {
	--top-preloader-size: 12px;
	--top-preloader-color: var(--color-bg-primary-1);
}

/* throbber */
.top-preloader-throbber {
	border-radius: 50%;
	border: 2px solid var(--top-preloader-color);
	border-top-color: transparent;
	border-left-color: transparent;
	width: var(--top-preloader-size);
	height: var(--top-preloader-size);
	display: inline-block;
	animation: top-preloader-throbber 0.9s linear infinite;
}

@keyframes top-preloader-throbber {
	100% { transform: rotate(360deg); }
}

/* circles */
.top-preloader-circles {
	--top-preloader-color: var(--color-line-1-opacity);
}

.top-preloader-circles > i {
	border-radius: 100%;
	background-color: var(--top-preloader-color);
	width: var(--top-preloader-size);
	height: var(--top-preloader-size);
	vertical-align: middle;
	display: inline-block;
	animation-duration: 500ms;
	animation-timing-function: linear;
	animation-iteration-count: infinite;
}
.top-preloader-circles > i:first-child {
	animation-name: top-preloader-circles_1;
}
.top-preloader-circles > i:not(:first-child):not(:last-child) {
	animation-name: top-preloader-circles_2;
}
.top-preloader-circles > i:last-child {
	animation-name: top-preloader-circles_3;
}

@keyframes top-preloader-circles_1 {
	0% {
		opacity: 0;
		transform: translateX(-12px);
	}
	30% {
		opacity: 1;
		transform: translateX(-2px);
	}
	100% {
		transform: translateX(6px);
	}
}

@keyframes top-preloader-circles_2 {
	from {
		transform: translateX(-6px);
	}
	to {
		transform: translateX(6px);
	}
}

@keyframes top-preloader-circles_3 {
	0% {
		transform: translateX(-6px);
	}
	70% {
		opacity: 1;
		transform: translateX(2px);
	}
	100% {
		opacity: 0;
		transform: translateX(12px);
	}
}
</style>
